var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3058 14.7378L7.46045 15.61L8.268 10.7L17.5226 1.47775C17.6727 1.32637 17.8514 1.20621 18.0482 1.12421C18.245 1.04222 18.4561 1 18.6693 1C18.8825 1 19.0936 1.04222 19.2904 1.12421C19.4873 1.20621 19.6659 1.32637 19.816 1.47775L21.5281 3.18976C21.6794 3.33991 21.7996 3.51854 21.8816 3.71536C21.9636 3.91217 22.0058 4.12328 22.0058 4.33649C22.0058 4.54971 21.9636 4.76081 21.8816 4.95763C21.7996 5.15444 21.6794 5.33307 21.5281 5.48322L12.3058 14.7378Z",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5738 15.5455V20.3908C19.5738 20.8191 19.4036 21.23 19.1007 21.5328C18.7978 21.8357 18.387 22.0059 17.9587 22.0059H2.61511C2.18676 22.0059 1.77595 21.8357 1.47305 21.5328C1.17016 21.23 1 20.8191 1 20.3908V5.04724C1 4.61889 1.17016 4.20808 1.47305 3.90518C1.77595 3.60229 2.18676 3.43213 2.61511 3.43213H7.46044",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.564a4937fa130d8a6574d43b3e1d4371.svg";
export { ForwardRef as ReactComponent };